import React from "react";
import "./styles.scss";
import SettingsAccordion from "./SettingsAccordion";

export default () => {
  const options = [
    { id: 1, text: "Everyone", value: "all" },
    { id: 2, text: "Following", value: "following" },
    { id: 3, text: "No one", value: "none" },
  ];
  return (
    <div className="privacy-settings">
      <h1 className="text-dark py-5">Privacy</h1>
      <div className="ml-4">
        <div className="row">
          <div className="col-md-8">
            <div className="account mb-4">
              <p className="font-weight-bold mb-1">Make My Account Private:</p>
              <small className="">When toggled on, your profile will not appear in searches or be able to be viewed by other users.</small>
            </div>
          </div>
          <div className="col-md-4 text-right">
            <div className="custom-control custom-switch mb-5">
              <input type="checkbox" className="custom-control-input bg-dark" id="privacy-switch" />
              <label className="custom-control-label" htmlFor="privacy-switch"></label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8 col-xl-10 pt-3">
            <div className="messages">
              <p className="font-weight-bold mb-1">Allow Messages From:</p>
            </div>
          </div>
          <div className="col-md-4 col-xl-2 text-right">
            <div className="select">
              <select className="form-control">
                <option disabled>Country</option>
                {options.map((o) => (
                  <option className="text-capitalize">{o.text}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <SettingsAccordion title="Security" items={[{ title: "Blocked Accounts", body: "lorem ipsum ..." }]} />
    </div>
  );
};
